<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
definePageMeta({
  layout: 'my-account-layout',
})

const localePath = useLocalePath()
const router = useRouter()
const { getCanonicalUrl } = useRouteHelper()
const { checkTokenReCAPTCHA } = useRecaptchaSite()

const data = ref({ email: '', returnNumber: '' })
const params = computed(
  () => router.currentRoute.value.params as ReturnPageParams & { email: string }
)

const searchOrder = async () => {
  await checkTokenReCAPTCHA('searchOrderDetail')
  navigateTo(
    getCanonicalUrl(
      localePath(
        `/track/returns/${data.value.email}/${data.value.returnNumber}`
      )
    )
  )
}

const goBackToOrdersSearch = () => {
  navigateTo(getCanonicalUrl(localePath(`/track/returns`)))
}

const handleInput = (value: string) => {
  if (value) return
  goBackToOrdersSearch()
}

onBeforeMount(() => {
  if (!params.value.return) return
  data.value.email = params.value.email
  data.value.returnNumber = params.value.return
})
</script>

<template>
  <div class="space-y-8 md:space-y-10 lg:space-y-14 print:space-y-0">
    
<FormKitLazyProvider config-file="true">
<header class="space-y-6 print:hidden">
      <p class="text-book-5 md:text-book-3 uppercase">
        {{ $ts('trackOrdersPage.myReturn') }}
      </p>
      <p class="text-book-6">
        {{ $ts('trackOrdersPage.insertReturnNumber') }}
      </p>
    </header>
    <section class="print:hidden">
      <FormKit
        v-model="data"
        type="form"
        :actions="false"
        :incomplete-message="false"
        @submit="searchOrder"
      >
        <InputsTextFields
          type="email"
          name="email"
          validation="required|email"
          :label="$ts('trackOrdersPage.email')"
          :show-remove-button="!!params.email"
          :validation-messages="{
            required: $ts('generic.requiredEmail'),
            email: $ts('generic.invalidEmail'),
          }"
          :disabled="!!params.return"
          @input="handleInput"
          @remove="goBackToOrdersSearch"
        />
        <InputsTextFields
          type="text"
          name="returnNumber"
          validation="required|validateOrderOrReturnNumber"
          :validation-rules="{ validateOrderOrReturnNumber }"
          :validation-messages="{
            required: $ts('fieldRequired'),
            validateOrderOrReturnNumber: $ts('generic.invalidReturnNumber'),
          }"
          :label="$ts('trackOrdersPage.returnNumber')"
          :action-text="!!params.return ? $ts('trackOrdersPage.edit') : ''"
          :show-remove-button="!!params.return"
          :disabled="!!params.return"
          @input="handleInput"
          @remove="goBackToOrdersSearch"
          @click-action-button="goBackToOrdersSearch"
        />
        <AtomsCta v-if="!params.return" class="mt-4">
          <template #label>
            {{ $ts('trackOrdersPage.search') }}
          </template>
        </AtomsCta>
      </FormKit>
    </section>

    <NuxtPage />
</FormKitLazyProvider>

  </div>
</template>
